<template>
  <div class="total">

    <div class="top-total">
    <span class="top-span">
      ارزش کل دارایی
    </span>
      <label>
    <span 
    class="bottom-span"
    
    >
      {{$toLocal(state.userInfo.totalTradesVolume , $decimal['TOMAN'])}}
    </span>
        <small style="color: #FFFFFF">تومان</small>
      </label>
    </div>
    <!-- <div class="bottom-total">
      <div class="item">
        <span>سود شما</span>
        <div class="fee-class">
          <span class="green number">+2%</span>
          <span>10,52548,56</span>

        </div>
      </div>

      <div class="item">
        <span>زیان شما</span>
        <div class="fee-class">
          <span class="red number">-2%</span>
          <span>10,52548,56</span>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "total-value"
}
</script>

<style lang="scss" scoped>
.total {
  background-image: url("../../../../assets/public/Chart.png");
  background-size: contain;
  background-position: bottom center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  gap: 30px;


  .top-total {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;

    .top-span {
      font-size: clamp(12px, 2vw, 16px);
      color: #FFFFFF;
    }

    .bottom-span {
      font-size: clamp(12px, 2vw, 16px);
      color: #FFFFFF;
    }
  }

  .bottom-total {
    display: flex;
    flex-direction: column;
    gap: 28px;

    .item {
      display: flex;
      justify-content: space-between;
      color: #FFFFFF;

      .fee-class {
        display: flex;
        gap: 5px;
        flex-direction: row;
      }
    }
  }
}
</style>